<template>
  <section class="sectionOuterBox" aria-label="Download Planbook mobile app">
    <div class="sectionInnerBox text-left py-12">
      <v-container class="container pt-5 text-center">
        <v-row>
          <v-col cols="12">
            <h2 class="cTrueBlue text32 pt-5 fontWeightBold">
              {{ $t('mobile.getApp.title') }}
            </h2>
          </v-col>
          <v-col cols="12">
            <div class="btnMobile btnAppStore">
              <a href="https://apps.apple.com/us/app/planbook-com/id1502332358"
                 target="_blank"
                 rel="noopener noreferrer"
                 :aria-label="$t('mobile.getApp.appStoreAriaLabel')">
                <img src="https://cdn.planbook.com/images/mobile-app-store.png" alt="">
              </a>
            </div>
            <div class="btnMobile">
              <a href="https://play.google.com/store/apps/details?id=com.planbook.lessonplanner"
                 target="_blank"
                 rel="noopener noreferrer"
                 :aria-label="$t('mobile.getApp.playStoreAriaLabel')">
                <img src="https://cdn.planbook.com/images/mobile-play-store.png" alt="">
              </a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class GetApp extends Vue {
}
</script>

<style lang="scss" scoped>
.btnMobile.btnAppStore {
  padding-left: 28px;
  padding-right: 28px;
}

.headlineSectionHeader .btnMobile {
  border: 1px solid #FFFFFF;
}

.btnMobile {
  position: relative;
  display: inline-block;
  padding: 8px 15px 5px 15px;
  background-color: black;
  border-radius: 8px;
  margin: 10px;
  transition: box-shadow 0.2s ease;
}

.btnMobile:focus-within {
  box-shadow: 0 0 0 3px #1677ff;
}

.btnMobile a {
  display: block;
  text-decoration: none;
  outline: none;
}

.btnMobile a>span {
  display: none;
}

.btnMobile img {
  cursor: pointer;
  height: 40px;
}
</style>
